import React, { useRef, useEffect } from 'react';
import { createReactEditorJS } from 'react-editor-js';
import Header from '@editorjs/header';
import List from '@editorjs/list';
import ImageTool from '@editorjs/image';
import LinkTool from '@editorjs/link';

const ReactEditorJS = createReactEditorJS();

const ContentViewer = ({ contentData }) => {
  const editorInstance = useRef(null);

  const EDITOR_JS_TOOLS = {
    header: Header,
    list: List,
    image: ImageTool,
    linkTool: LinkTool,
  };

  useEffect(() => {
    if (editorInstance.current) {
      // Setting the readOnly mode and disabling all editing features
      editorInstance.current.setReadOnly(true);
    }
  }, []);

  return (
    <div>
      <ReactEditorJS
        readOnly={true}  // This prop sets the editor to readOnly mode
        instanceRef={(instance) => editorInstance.current = instance}
        tools={EDITOR_JS_TOOLS}
        defaultValue={contentData} // The content data should be the saved data from the editor
      />
    </div>
  );
};

export default ContentViewer;
